import { ConfiguratorRequest } from 'components/ordering/configurator/api/configurator-request.js'
import {
  MultiStepResponseDTO,
  parseMultiStepResponseDTO
} from 'components/ordering/configurator/api/dtos/multi-step-response-dto.js'
import { StepSelectionData } from 'components/ordering/configurator/api/dtos/step-selection-data.js'
import { StatusCodeToError } from 'components/ordering/configurator/api/dtos/error.js'

type PostMultiStepPayload = {
  productSlug: string
  productId: number
  selections: Record<string, StepSelectionData>
}


const EXPECTED_ERRORS = [404] as const
type ExpectedErrors = StatusCodeToError<typeof EXPECTED_ERRORS[number]>

export class PostMultiStep extends ConfiguratorRequest<MultiStepResponseDTO, ExpectedErrors> {
  path: string
  override init: RequestInit
  override expectedErrors: readonly number[] = EXPECTED_ERRORS

  constructor({ productSlug, productId, selections }: PostMultiStepPayload) {
    super()
    this.path = `p/${productSlug}/${productId}/configurator/multi-step/`
    this.init = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(selections),
    }
  }

  override parseResponse = parseMultiStepResponseDTO
}
